<template>
  <div>
    <Header Act="1"></Header>
    <!-- <div class="yi"><img src="../assets/1.png" alt=""></div> -->
    <Banner></Banner>
    <div>
      <div class="login-container">
        <div class="news-container">
          <div class="breadcrumb">
            <!-- <span>首页</span>
            <span class="separator">/</span>
            <span>资讯</span> -->
          </div>
          
          <div class="news-header">
            <span class="news-title">最新资讯</span>
            <router-link to="/zhibo-list" class="more-link">查看全部 ></router-link>
          </div>
          <div class="featured-news">
            <div
              v-for="item in lastZhiboList"
              :key="item.id"
              class="featured-item"
              @click="openZhibo(item.address)"
              style="display: flex; flex-direction: column; cursor: pointer;"
            >
              <img :src="item.avatar" :alt="item.name" style="width: 100%; max-height: 280px; object-fit: contain; background: #f8f8f8; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); display: block; margin: 0 auto;" />
              <div style="padding: 8px 0 0 0; text-align: center; font-size: 15px; color: #333; background: rgba(255,255,255,0.9);">
                {{ item.name }}
              </div>
              <div style="text-align: center; font-size: 13px; color: #888; background: rgba(255,255,255,0.7);">
                {{ item.beginTime }} ~ {{ item.endTime }}
              </div>
            </div>
          </div>
          <div class="news-list">
            <div class="news-item" @click="navigateToArticle(3)">
              <div class="news-content">
                <h3>您点题，我出书——"百姓巡常行"项目健康科普系列图书选题调研全面开启</h3>
                <p class="news-excerpt">健康中国行动在祖国大地上如火如荼地开展着，各类机构和社会组织也用实际行动纷纷持续助力。由中国健康教育中心指导，北京整合医学学会主办的"健康中国行动——百姓健康卫士公益科普'百姓巡常行'项目"正是这样的一个实践项目。该项目将通过促进健康科普作品创作和传播、出版百姓期待的健康科普系列图书等形式，形成健康科普和健康促进合力，持续、稳定地开展健康科普活动。</p>
                <div class="news-info">
                  <span>百姓巡常行</span>
                  <!-- <span>XXXXX医院</span> -->
                  <span>1524次浏览</span>
                </div>
              </div>
              <div class="news-img">
                <img src="../../assets/小资讯1.png" alt="新闻图片">
              </div>
            </div>
            <div class="news-item" @click="navigateToArticle(4)">
              <div class="news-content">
                <h3>您点题 我出书｜百姓健康卫士公益科普"百姓巡常行"项目继续征集选题</h3>
                <p class="news-excerpt">健康中国行动的推进过程中，健康科普工作发挥着至关重要的作用。由中国健康教育中心指导，北京整合医学学会主办的"健康中国行动——百姓健康卫士公益科普'百姓巡常行'项目"积极响应号召，致力于出版贴合百姓需求的健康科普系列作品。继河南新乡调研科普图书主题取得丰硕成果后，项目调研组于3月12-14日赶赴山东菏泽，深入开展线下调研访谈活动，聚焦不同群体的健康需求，为健康科普图书的创作与出版收集第一手资料。</p>
                <div class="news-info">
                  <span>百姓巡常行</span>
                  <!-- <span>XXXXX医院</span> -->
                  <span>1376次浏览</span>
                </div>
              </div>
              <div class="news-img">
                <img src="../../assets/小资讯2.png" alt="新闻图片">
              </div>
            </div>
          </div>
        </div>
        <div class="login-page">
          <!-- 未登录时显示 -->
          <div v-if="!isLoggedIn">
            <!-- <h3>Hello!<br> {{ isRegister ? '欢迎注册' : '欢迎登录' }}</h3> -->
            <p>{{ isRegister ? '注册' : '登录' }}</p>
            <div v-if="!isRegister" class="login-tabs">
              <button @click="activeTab = 'verifyCode'" :class="{ active: activeTab === 'verifyCode' }">验证码登录</button>
              <button @click="activeTab = 'password'" :class="{ active: activeTab === 'password' }">密码登录</button>
            </div>
            <!-- 验证码登录 -->
            <form v-if="!isRegister && activeTab === 'verifyCode'" @submit.prevent="handleVerifyCodeLogin" class="login-form">
              <input type="text" v-model="mobile" placeholder="手机号" required />
              <div class="captcha">
                <input type="text" v-model="captcha" placeholder="验证码" required />
                <button @click="sendCaptcha" :class="['send-captcha-btn', {'active': isSliderVerified}]" :disabled="!isSliderVerified">发送验证码</button>
              </div>
              <!-- 添加滑动验证条 -->
              <div class="slider-container">
                <div class="slider-mask" :style="{width: sliderWidth + 'px'}"></div>
                <div class="slider-text">{{ sliderText }}</div>
                <div class="slider-button" 
                     @mousedown="startSlide"
                     @touchstart="startSlide"
                     :style="{left: sliderLeft + 'px'}">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div class="checkbox">
                <input type="checkbox" v-model="agreeTerms" />
                <label>我已阅读<a href="#">用户协议</a>与<a href="#">隐私协议</a></label>
                <div class="register-link">
                  <label><a href="#" @click.prevent="showForgotPasswordDialog">忘记密码</a></label>
                  <label><a href="#" @click.prevent="goToRegister">注册</a></label>            
                </div>
              </div>
              <button type="submit" class="login-btn">立即登录</button>
              <div class="san"><a href="/#/requirements"><img src="../../assets/作品提交.png"></a></div>
            </form>
            <!-- 密码登录 -->
            <form v-else-if="!isRegister && activeTab === 'password'" @submit.prevent="handlePasswordLogin" class="login-form">
              <input type="text" v-model="SetData.username" placeholder="用户名" required />
              <input type="password" v-model="SetData.password" placeholder="密码" required />
              <div class="captcha">
                <input type="text" v-model="SetData.code" placeholder="验证码" required />
                <img :src="captchaUrl" @click="refreshCaptcha" class="captcha-img" alt="验证码">
              </div>
              <div class="checkbox">
                <input type="checkbox" v-model="agreeTerms" />
                <label>我已阅读<a href="#">用户协议</a>与<a href="#">隐私协议</a></label>
                <div class="register-link">
                  <label><a href="#" @click.prevent="showForgotPasswordDialog" >忘记密码</a></label>
                  <label><a href="#" @click.prevent="goToRegister">注册</a></label>
                </div>
              </div>
              <button type="submit" class="login-btn">立即登录</button>
              <div class="san"><a href="/#/requirements"><img src="../../assets/作品提交.png"></a></div>
            </form>
            <!-- 注册 -->
            <form v-else class="form-content">
              <input type="text" v-model="SetData.username" placeholder="用户名" required />
              <input type="text" v-model="SetData.nickName" placeholder="姓名" required />
              <select v-model="SetData.sex" required>
                <option value="0">男</option>
                <option value="1">女</option>
              </select>
              <input type="text" v-model="SetData.email" placeholder="邮箱" required />
              <input type="text" v-model="SetData.phonenumber" placeholder="手机号" required />
              <input type="text" v-model="SetData.hospitalId" placeholder="所属单位" required />
              <input type="password" v-model="SetData.password" placeholder="密码" required />
              <div class="captcha">
                <input type="text" v-model="SetData.code" placeholder="验证码" required />
                <img :src="captchaUrl" @click="refreshCaptcha" class="captcha-img" alt="验证码">
              </div>
              <div class="checkbox">
                <input type="checkbox" v-model="agreeTerms" />
                <label>我已阅读<a href="#">用户协议</a>与<a href="#">隐私协议</a></label>
                <div class="register-link">
                  <label><a href="#" @click.prevent="goToRegister">注册</a></label>
                  <label><a href="#" @click.prevent="showForgotPasswordDialog" class="forgot-text">忘记密码</a></label>
                </div>
              </div>
              <button @click="handleRegister" class="login-btn">立即注册</button>
            </form>
          </div>
          
          <!-- 登录后显示 -->
          <div v-else class="user-logged-in">
            <div class="user-buttons">
              <!-- 添加欢迎语 -->
              <div class="welcome-text">欢迎登录</div>
              
              <div class="user-action-btn" @click="goToUserInfo">
                进入个人中心
              </div>
              <div class="user-action-btn" @click="handleLogout">
                退出
              </div>
              
              <!-- 添加作品提交图片 -->
              <div class="san">
                <a href="/#/requirements">
                  <img src="../../assets/作品提交.png">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="project-sections">
      <div class="section-tabs">
        <button class="tab" 
                :class="{ active: activeSection === 'background' }" 
                @click="scrollToSection('background')">项目背景</button>
        <button class="tab" 
                :class="{ active: activeSection === 'overview' }" 
                @click="scrollToSection('overview')">项目概述</button>
        <button class="tab" 
                :class="{ active: activeSection === 'organization' }" 
                @click="scrollToSection('organization')">组织架构</button>
        <button class="tab" 
                :class="{ active: activeSection === 'goals' }" 
                @click="scrollToSection('goals')">项目目标</button>
      </div>
      <div class="section-tou" id="background">
        <h2>项目背景</h2>
        <div class="section-neirong">
          <p>党和政府历来高度重视人民群众的身体健康，尤其是党的十八大以来，相继出台了《"健康中国2030"规划纲要》、《关于实施健康中国行动的意见》、《健康中国行动（2019-2030年）》、《关于深化卫生专业技术人员职称制度改革的指导意见》、《全民健康素养提升三年行动方案（2024-2027年）》、《关于实施2025年卫生健康系统为民服务实事项目的通知》等系列重要政策文件。，习近平总书记在党的二十大报告中指出："把保障人民健康放在优先发展的战略位置，完善人民健康促进政策。"健康科普和健康促进成为国家战略层面的重要行动。</p>
        </div>
      </div>

      <div class="section-er" id="overview">
        <h2>项目概述</h2>
        <div class="section-neirong">
          <p>为积极响应党和国家有关人民群众健康的政策、指示和精神，贯彻落实有关重要举措和要求，充分发挥卫生健康相关行业学会作用，助推健康知识普及重大专项行动走近、走深、走实，由中国健康教育中心指导、北京整合医学学会主办的"健康中国行动——百姓健康卫士公益科普'百姓巡常行'项目"已于2025年1月正式启动。通过征集和发布优质健康科普作品(科普短视频、科普讲座、科普文章等)、出版健康科普系列丛书、举办新时代健康科普作品征集大赛等形式形成健康科普和健康促进合力，持续、稳定地开展健康科普活动，打造科普传播品牌和精品活动，打造优质高效的健康科普知识发布和传播机制。</p>
        </div>
      </div>

      <div class="section-san" id="organization">
        <h2>组织架构</h2>
        <div class="section-neirong org-structure">
          <!-- 第一层级：突出显示的单位 -->
          <div class="org-primary">
            <div class="org-row primary-row">
              <div class="org-item primary-item">
                <div class="org-label primary-label">指导单位：</div>
                <div class="org-content primary-content">中国健康教育中心</div>
              </div>
            </div>
            
            <div class="org-row primary-row">
              <div class="org-item primary-item">
                <div class="org-label primary-label">主办单位：</div>
                <div class="org-content primary-content">北京整合医学学会</div>
              </div>
            </div>

            <div class="org-row primary-row">
              <div class="org-item primary-item">
                <div class="org-label primary-label">协办单位：</div>
                <div class="org-content primary-content">全国各省健康教育中心（所）</div>
              </div>
            </div>
          </div>

          <!-- 第二层级：其他单位 -->
          <div class="org-secondary">
            <div class="org-columns">
              <div class="org-column">
                <div class="org-row">
                  <div class="org-item">
                    <div class="org-label">支持单位：</div>
                    <div class="org-content">中国人口与健康出版社</div>
                  </div>
                </div>

                <div class="org-row">
                  <div class="org-item">
                    <div class="org-label">出版单位：</div>
                    <div class="org-content">人民卫生出版社、中国人口与健康出版社、中国科学技术出版社</div>
                  </div>
                </div>
              </div>

              <div class="org-column">
                <div class="org-row">
                  <div class="org-item">
                    <div class="org-label">媒体合作：</div>
                    <div class="org-content">健康报社、中国药业科普专刊、《糖尿病之友》杂志等</div>
                  </div>
                </div>

                <div class="org-row">
                  <div class="org-item">
                    <div class="org-label">评审/编审专家：</div>
                    <div class="org-content">国家健康科普专家库专家、北京整合医学学会各学科专家库专家</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="goals-section" id="goals">
          <h2>项目目标</h2>
          <div class="goals-container">
            <div class="goal-item">
              <div class="goal-icon">
                <img src="../../assets/目标1.png" alt="目标1">
              </div>
            </div>
            <div class="goal-item">
              <div class="goal-icon">
                <img src="../../assets/目标2.png" alt="目标2">
              </div>
            </div>
            <div class="goal-item">
              <div class="goal-icon">
                <img src="../../assets/目标3.png" alt="目标3">
              </div>
            </div>
            <div class="goal-item">
              <div class="goal-icon">
                <img src="../../assets/目标4.png" alt="目标4">
              </div>
            </div>
            <div class="goal-item">
              <div class="goal-icon">
                <img src="../../assets/目标5.png" alt="目标5">
              </div>
            </div>
            <div class="goal-item">
              <div class="goal-icon">
                <img src="../../assets/目标6.png" alt="目标6">
              </div>
            </div>
            <div class="goal-item">
              <div class="goal-icon">
                <img src="../../assets/目标7.png" alt="目标7">
              </div>
            </div>
            <div class="goal-item">
              <div class="goal-icon">
                <img src="../../assets/目标8.png" alt="目标8">
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="implementation-plan">
      <div class="plan-content">
        <h2>项目实施规划</h2>
        <div class="plan-stages">
          <div class="plan-stage">
            <div class="stage-content">
              <p>深入了解公众对健康科普知识的需求、认知水平及获取渠道偏好，了解医务人对于科普创作的动力和意愿，分析当前健康科普工作存在的问题是不足，为科普作品创作与传播提供科学依据。</p>
              <div class="stage-items">
                <div class="stage-text">• 线下访谈</div>
                <div class="stage-text">• 线上问卷</div>
                <div class="stage-text">• 专家研讨</div>
              </div>
            </div>
          </div>

          <div class="plan-stage">
            <div class="stage-content">
              <p>广泛收集医务人员创作的科普作品，丰富科普内容库，激发专业人士参与健康科普创作的热情。征集作品的形式包括健康科普短视频、文章、图画、讲座。</p>
              <div class="stage-items">
                <div class="stage-text">• 发布征集通知</div>
                <div class="stage-text">• 作品收集与审核</div>
                <div class="stage-text">• 作品发布</div>
              </div>
            </div>
          </div>

          <div class="plan-stage">
            <div class="stage-content">
              <p>整合优质科普资源，针对不同人群，联合3大国有出版单位出版具有权威性、可读性和跨媒介传播潜力的科普图书，拓展科普知识传播的深度与广度。</p>
              <div class="stage-items">
                <div class="stage-text">• 选题与策划</div>
                <div class="stage-text">• 定向约稿（含视频）</div>
                <div class="stage-text">• 征集筛选</div>
                <div class="stage-text">• 统稿与审核</div>
                <div class="stage-text">• 出版发行</div>
              </div>
            </div>
          </div>

          <div class="plan-stage">
            <div class="stage-content">
              <p>健康靠"普"——新时代百姓健康卫士技能大赛【健康新语(创作计划)】</p>
              <p>科普中国——新时代健康传播达人评选【健康声波(传播计划)】</p>
            </div>
          </div>
        </div>
        <div class="gradient-bottom">
          <div class="button-container">
            <button class="gradient-button" :class="{ active: activeButton === 1 }" @click="setActiveButton(1)">
              健康科普需求调研
            </button>
            <button 
              class="gradient-button" :class="{ active: activeButton === 2 }" @click="setActiveButton(2)">
              健康科普作品征集赛
            </button>
            <button class="gradient-button" :class="{ active: activeButton === 3 }" @click="setActiveButton(3)">
              健康科普图书出版
            </button>
            <button class="gradient-button" :class="{ active: activeButton === 4 }" @click="setActiveButton(4)">
              系列大赛
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加精彩回顾模块 -->
    <!-- <div class="jingcai">
      <div class="jingcai-content">
        <h2>活动回顾</h2>
        <div class="jingcai-container">
        
          <div class="jingcai-left">
            <div class="jingcai-img">
              <img src="../../assets/大会.png" alt="会议合影">
            </div>
            <p class="jingcai-info">启动嘉宾：樊代明院士、郎景和院士、徐兵河院士、吉训明院士、黄晓军院士、中国健康教育中心李英华副主任......</p>
          </div>
        
          <div class="jingcai-right">
            <h3>活动回顾</h3>
            <ul class="jingcai-list">
              <li v-for="index in 5" :key="index" class="jingcai-list-item">
                <span class="jingcai-event">第二届北京整合医学学术大会</span>
                <div class="jingcai-guests">
                  启动嘉宾：樊代明院士、郎景和院士、徐兵河院士、吉训明院士、黄晓军院士、中国健康教育中心李英华副主任、中国科学技术出版社秦德继社长、《健康报》杨秋兰副总编辑、中国人口与健康出版社周炳然副总编辑、《中国中医药报》陆静社长、北京整合医学学会杜亚宏常务副会长
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <Footer></Footer>

    <!-- 忘记密码对话框 -->
    <el-dialog title="忘记密码" :visible.sync="forgotPasswordDialogVisible" :width="isMobile ? '90%' : '30%'" :close-on-click-modal="false">
        <div class="password-form">
            <div class="form-item">
                <div class="form-label">手机号</div>
                <el-input v-model="forgotPasswordForm.phoneNumber" placeholder="请输入手机号"></el-input>
            </div>
            <div class="form-item">
                <div class="form-label">验证码</div>
                <div class="verify-code-input">
                    <el-input v-model="forgotPasswordForm.code" placeholder="请输入验证码"></el-input>
                    <el-button 
                        type="primary" 
                        :disabled="forgotCountdown > 0"
                        @click="sendForgotVerifyCode"
                        class="send-code-btn">
                        {{ forgotCountdown > 0 ? `${forgotCountdown}秒后重试` : '获取验证码' }}
                    </el-button>
                </div>
            </div>
            <div class="form-item">
                <div class="form-label">新密码</div>
                <el-input type="password" v-model="forgotPasswordForm.newPassword" placeholder="请输入新密码"></el-input>
            </div>
            <div class="form-item">
                <div class="form-label">确认密码</div>
                <el-input type="password" v-model="forgotPasswordForm.confirmPassword" placeholder="请再次输入新密码"></el-input>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="forgotPasswordDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="resetPassword" style="background-color: #58C1B6; border-color: #58C1B6;">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import Header from '../header/head.vue';
import Footer from '../header/footer.vue';
import Banner from '../banner/Banner.vue';
import { checkTokenExpiration, clearLoginInfo } from '@/utils/auth'
import { 
  initWxShare, 
  forceInitWxShare, 
  isWeixinBrowser, 
} from '@/utils/wxShare';

export default {
  name: 'ShouYe',
  components: {
    Header,
    Banner,
    Footer,
  },
  data() {
    return {
      activeTab: 'verifyCode',
      isRegister: false,
      SetData: {
        code: "",
        email: "",
        nickName: "",
        password: "",
        phonenumber: "",
        hospitalId: "",
        sex: "0",
        username: "",
        uuid: "",
      },
      mobile: '',
      captcha: '',
      username: '',
      password: '',
      confirmPassword: '',
      name: '',
      agreeTerms: false,
      captchaUrl: '',
      isSliderVerified: false,
      sliderLeft: 0,
      sliderWidth: 0,
      isDragging: false,
      startX: 0,
      sliderStartLeft: 0,
      sliderText: '请向右滑动验证',
      activeSection: 'background',
      isLoggedIn: false,
      activeButton: 1,
      isMobile: false,
      forgotPasswordDialogVisible: false,
      forgotPasswordForm: {
        phoneNumber: "",
        code: "",
        newPassword: "",
        confirmPassword: ""
      },
      forgotCountdown: 0,
      newsArticles: [
        {
          id: 1,
          title: '健康中国行动—百姓健康卫士公益科普"百姓巡常行"项目启动',
          imageUrl: "../../assets/最新资讯.png",
          content: '为贯彻落实党中央、国务院关于深化医药卫生体制改革的决策部署，积极推进"健康中国2030"规划纲要，北京整合医学学会组织开展了"健康中国行动—百姓健康卫士公益科普"百姓巡常行"项目。该项目旨在通过整合优质医疗资源和专业医护团队，加快建设专业化医疗科普知识平台，让健康科普知识深入人心。'
        },
        {
          id: 2,
          title: '百姓巡常行项目健康科普作品征集活动正式启动',
          imageUrl: "../../assets/最新资讯1.png",
          content: '百姓巡常行项目健康科普作品征集活动现已正式启动，面向全国医疗卫生机构的专业医务人员征集健康科普作品。征集内容包括科普文章、科普图画、科普视频和科普讲座等多种形式。欢迎各位医务工作者积极参与，共同为提升全民健康素养贡献力量。'
        },
        {
          id: 3,
          title: '您点题，我出书——"百姓巡常行"项目健康科普系列图书选题调研全面开启',
          imageUrl: "../../assets/小资讯1.png",
          content: "健康中国行动在祖国大地上如火如荼地开展着，各类机构和社会组织也用实际行动纷纷持续助力。由中国健康教育中心指导，北京整合医学学会主办的\"健康中国行动——百姓健康卫士公益科普'百姓巡常行'项目\"（下文简称为\"百姓巡常行\"项目）正是这样的一个实践项目。该项目将通过促进健康科普作品创作和传播、出版百姓期待的健康科普系列图书等形式，形成健康科普和健康促进合力，持续、稳定地开展健康科普活动。",
          views: "1524"
        },
        {
          id: 4,
          title: '您点题 我出书｜百姓健康卫士公益科普"百姓巡常行"项目继续征集选题',
          imageUrl: "../../assets/小资讯2.png",
          content: "健康中国行动的推进过程中，健康科普工作发挥着至关重要的作用。由中国健康教育中心指导，北京整合医学学会主办的\"健康中国行动——百姓健康卫士公益科普'百姓巡常行'项目\"积极响应号召，致力于出版贴合百姓需求的健康科普系列作品。继河南新乡调研科普图书主题取得丰硕成果后，项目调研组于3月12-14日赶赴山东菏泽，深入开展线下调研访谈活动，聚焦不同群体的健康需求，为健康科普图书的创作与出版收集第一手资料。",
          views: "1376"
        }
      ],
      // 添加微信分享相关的数据
      shareInitialized: false,
      isWxShareInitializing: false,
      initRetryCount: 0,
      initRetryTimer: null,
      pageFullyLoaded: false,
      zhiboList: [],
    };
  },
  created() {
    this.getCaptcha();
    // 检查登录状态
    const token = localStorage.getItem('token');
    this.isLoggedIn = !!token;
    
    // 获取服务器存储的浏览量数据
    this.getArticlesViews();

    // 初始化微信分享
    if (isWeixinBrowser()) {
      this.initializeWxShare(true);
    }

    // 监听页面可见性变化
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    // 监听页面完全加载
    window.addEventListener('load', this.handlePageLoaded);

    // 获取直播列表
    this.$get('/api/v1/works/zhibo/list?pageNum=1&pageSize=2').then(res => {
      if (res.data && (res.data.code === 0 || res.data.code === 200) && Array.isArray(res.data.rows)) {
        this.zhiboList = res.data.rows;
      }
    });
  },
  beforeDestroy() {
    // 清理事件监听器
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('load', this.handlePageLoaded);
    // 清理定时器
    if (this.initRetryTimer) {
      clearTimeout(this.initRetryTimer);
    }
  },
  methods: {
    sendCaptcha() {
      if (!this.isSliderVerified) {
        return;
      }
      if (!this.mobile) {
        alert("请输入手机号！");
        return;
      }
      
      // 调用发送短信接口，使用POST请求但参数放在URL中
      this.$post(`/smsSend?phoneNumber=${this.mobile}`).then(res => {
        if (res.data.code === 200) {
          this.$message.success(res.data.msg || '验证码已发送，请查收！');
        } else {
          this.$message.error(res.data.msg || '验证码发送失败');
        }
        
        // 重置滑动验证
        this.isSliderVerified = false;
        this.sliderLeft = 0;
        this.sliderWidth = 0;
        this.sliderText = '请向右滑动验证';
      }).catch(err => {
        console.error('发送验证码失败:', err);
        this.$message.error('验证码发送失败');
      });
    },
    handleVerifyCodeLogin() {
      if (!this.agreeTerms) {
        alert("请同意用户协议与隐私协议！");
        return;
      }
      if (!this.captcha) {
        alert("请输入验证码！");
        return;
      }
      
      // 将参数放在URL中传递
      this.$post(`/loginSms?phoneNumber=${this.mobile}&code=${this.captcha}`).then((res) => {
        if (res.data.code === 200) {
          // 使用 token 值
          const token = res.data.data;
          this.$auth.setToken(token);
          
          // 获取用户信息
          this.$get('/getInfo').then(infoRes => {
            if (infoRes.data.code === 200) {
              // 使用 auth.js 中的方法设置用户信息
              this.$auth.setUserInfo(infoRes.data.user);
              
              // 更新登录状态
              this.isLoggedIn = true;
              
              // 显示成功消息
              this.$message({ message: '登录成功', type: 'success' });
              
              // 更新header显示
              this.$bus.$emit('updateUser');
              
              // 跳转到用户信息页面
              // this.$router.push('/');
            }
          }).catch(err => {
            console.error("登录失效，请重新登录:", err);
            this.$message.error('登录失效，请重新登录');
          });
        } else {
          this.$message({ message: res.data.msg, type: 'error' });
        }
      }).catch(err => {
        console.error('登录失败:', err);
        this.$message.error('登录失败');
      });
    },
    getCaptcha() {
      this.$get('/captchaImage').then((res) => {
        if (res.data.code == 200) {
          this.captchaUrl = "data:image/gif;base64," + res.data.img;
          this.SetData.uuid = res.data.uuid;
        }
      });
    },
    refreshCaptcha() {
      this.getCaptcha();
    },
    handlePasswordLogin() {
      if (!this.SetData.username || !this.SetData.password || !this.SetData.code) {
        alert("请填写完整信息！");
        return;
      }
      if (!this.agreeTerms) {
        alert("请同意用户协议与隐私协议！");
        return;
      }

      const loginData = {
        username: this.SetData.username,
        password: this.SetData.password,
        code: this.SetData.code,
        uuid: this.SetData.uuid
      };
      
      this.$post('/login', loginData).then((res) => {
        if (res.data.code === 200) {
          // 使用 auth.js 中的方法设置 token
          this.$auth.setToken(res.data.token);
          
          // 获取用户信息
          this.$get('/getInfo').then(infoRes => {
            if (infoRes.data.code === 200) {
              // 使用 auth.js 中的方法设置用户信息
              this.$auth.setUserInfo(infoRes.data.user);
              
              // 更新登录状态
              this.isLoggedIn = true;
              
              // 显示成功消息
              this.$message({ message: '登录成功', type: 'success' });
              
              // 更新header显示
              this.$bus.$emit('updateUser');
              
              // 跳转到用户信息页面
              // this.$router.push('/');
            }
          }).catch(err => {
            console.error("登录失效，请重新登录:", err);
            this.$message.error('登录失效，请重新登录');
          });
        } else {
          this.$message({ message: res.data.msg, type: 'error' });
          this.getCaptcha(); // 刷新验证码
        }
      });
    },
    handleRegister() {
      if (!this.SetData.username || !this.SetData.nickName || !this.SetData.password || 
          !this.SetData.email || !this.SetData.phonenumber || !this.SetData.code) {
          alert("请填写完整信息！");
          return;
      }
      if (!this.agreeTerms) {
          alert("请同意用户协议与隐私协议！");
          return;
      }

      const registerData = {
          code: this.SetData.code,
          email: this.SetData.email,
          nickName: this.SetData.nickName,
          password: this.SetData.password,
          phonenumber: this.SetData.phonenumber,
          hospitalId: this.SetData.hospitalId,
          sex: this.SetData.sex,
          username: this.SetData.username,
          uuid: this.SetData.uuid
      };

      this.$post('/register', registerData).then((res) => {
          if (res.data.code == 200) {
              this.$message({ message: res.data.msg, type: 'success' });
              this.isRegister = false;
          } else {
              this.$message({ message: res.data.msg, type: 'error' });
              this.getCaptcha();
          }
      });
    },
    startSlide(e) {
      this.isDragging = true;
      this.startX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      this.sliderStartLeft = this.sliderLeft; // 保存开始拖动时的位置
      
      // 添加全局鼠标事件监听
      document.addEventListener('mousemove', this.moveSlide);
      document.addEventListener('mouseup', this.endSlide);
      
      // 添加触摸事件支持
      document.addEventListener('touchmove', this.moveSlide, { passive: false });
      document.addEventListener('touchend', this.endSlide);
      
      // 防止触摸事件时页面滚动
      if (e.type === 'touchstart') {
        e.preventDefault();
      }
    },
    
    moveSlide(e) {
      if (!this.isDragging) return;
      
      // 获取当前位置，支持鼠标和触摸事件
      const currentX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      
      const containerWidth = 250; // 固定容器宽度
      const buttonWidth = 34; // 滑块宽度
      
      // 计算移动距离
      const deltaX = currentX - this.startX;
      let newLeft = this.sliderStartLeft + deltaX;
      
      // 限制滑动范围
      newLeft = Math.max(0, Math.min(newLeft, containerWidth - buttonWidth));
      
      this.sliderLeft = newLeft;
      this.sliderWidth = newLeft + buttonWidth;
      
      // 判断是否滑到末端（增加精确度要求）
      if (newLeft >= containerWidth - buttonWidth - 2) { // 只允许最后2px的误差
        this.verifySlider();
      }
      
      // 防止触摸事件时页面滚动
      if (e.type === 'touchmove') {
        e.preventDefault();
      }
    },
    
    endSlide() {
      this.isDragging = false;
      
      // 移除所有事件监听
      document.removeEventListener('mousemove', this.moveSlide);
      document.removeEventListener('mouseup', this.endSlide);
      document.removeEventListener('touchmove', this.moveSlide);
      document.removeEventListener('touchend', this.endSlide);
      
      // 如果没有验证成功，则回到起点
      if (!this.isSliderVerified) {
        this.sliderLeft = 0;
        this.sliderWidth = 0;
      } else {
        // 如果验证成功，确保滑块到达终点
        const containerWidth = 250;
        const buttonWidth = 34;
        this.sliderLeft = containerWidth - buttonWidth;
        this.sliderWidth = containerWidth;
      }
    },
    
    verifySlider() {
      this.isSliderVerified = true;
      this.sliderText = '验证通过';
    },
    scrollToSection(sectionId) {
      this.activeSection = sectionId;
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80; // 添加一个偏移量，避免标题被导航栏遮挡
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    },
    
    handleScroll() {
      const sections = ['background', 'overview', 'organization', 'goals'];
      const offset = 100; // 滚动检测的偏移量
      
      for (let section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= offset && rect.bottom >= offset) {
            this.activeSection = section;
            break;
          }
        }
      }
    },
    goToUserInfo() {
      const status = checkTokenExpiration();
      if (status.expired) {
        clearLoginInfo();
        this.$confirm(status.message, '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(() => {
          this.$router.push('/');
        }).catch(() => {
          this.$router.push('/');
        });
        return;
      }
      this.$router.push('/UserInfo');
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearLoginInfo();
        this.isLoggedIn = false;
        this.$message.success('已退出登录');
        // this.$router.push('/');
      }).catch(() => {});
    },
    setActiveButton(buttonIndex) {
      this.activeButton = buttonIndex; // 更新选中的按钮
    },
    goToRegister() {
      this.$router.push('/register');
    },
    
    // 重新添加导航到文章页的方法
    navigateToArticle(articleId) {
      // 找到对应的文章信息
      const article = this.newsArticles.find(item => item.id === articleId);
      if (article) {
        // 将文章信息存储到localStorage，以便在文章页面获取
        localStorage.setItem('currentArticle', JSON.stringify(article));
        // 跳转到文章页面
        this.$router.push('/article/' + articleId);
      }
    },
    // 从服务器获取所有文章的浏览量
    getArticlesViews() {
      // 这里应该调用后端API获取文章浏览量
      // 实际项目中应当实现这个API
      // this.$get('/api/articles/views').then(response => {
      //   const viewsData = response.data;
      //   // 更新数组中的浏览量
      //   this.newsArticles.forEach(item => {
      //     if (viewsData[item.id]) {
      //       item.views = viewsData[item.id];
      //     }
      //   });
      // }).catch(error => {
      //   console.error('获取浏览量失败:', error);
      // });
    },
    showForgotPasswordDialog() {
      this.forgotPasswordDialogVisible = true;
      this.forgotPasswordForm = {
        phoneNumber: "",
        code: "",
        newPassword: "",
        confirmPassword: ""
      };
    },
    sendForgotVerifyCode() {
      if (!this.forgotPasswordForm.phoneNumber) {
        this.$message.warning("手机号不能为空");
        return;
      }
      
      this.$post(`/smsSend?phoneNumber=${this.forgotPasswordForm.phoneNumber}`).then(res => {
        if (res.data.code === 200) {
          this.$message.success("验证码发送成功");
          this.startForgotCountdown();
        } else {
          this.$message.error(res.data.msg || "验证码发送失败");
        }
      }).catch(err => {
        console.error("验证码发送失败:", err);
        this.$message.error("验证码发送失败");
      });
    },
    startForgotCountdown() {
      this.forgotCountdown = 60;
      const timer = setInterval(() => {
        this.forgotCountdown--;
        if (this.forgotCountdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    resetPassword() {
      // 验证表单
      if (!this.forgotPasswordForm.phoneNumber) {
        this.$message.warning("请输入手机号");
        return;
      }
      
      if (!this.forgotPasswordForm.code) {
        this.$message.warning("请输入验证码");
        return;
      }
      
      if (!this.forgotPasswordForm.newPassword) {
        this.$message.warning("请输入新密码");
        return;
      }
      
      if (this.forgotPasswordForm.newPassword !== this.forgotPasswordForm.confirmPassword) {
        this.$message.warning("两次输入的密码不一致");
        return;
      }
      
      // 提交重置密码请求
      this.$post("/api/v1/works/updatePwd", {
        phoneNumber: this.forgotPasswordForm.phoneNumber,
        code: this.forgotPasswordForm.code,
        newPassword: this.forgotPasswordForm.newPassword
      }).then(res => {
        if (res.data.code === 200) {
          this.$message.success("密码重置成功，请重新登录");
          this.forgotPasswordDialogVisible = false;
          
          // 清除登录信息
          clearLoginInfo();
          
          // 延迟跳转到登录页面
          setTimeout(() => {
            this.$router.push('/');
          }, 1500);
        } else {
          this.$message.error(res.data.msg || "密码重置失败");
        }
      }).catch(err => {
        console.error("密码重置失败:", err);
        this.$message.error("密码重置失败");
      });
    },
    // 获取分享数据
    getShareData() {
      return {
        title: '百姓巡常行',
        desc: '健康中国行动——百姓健康卫士公益科普"百姓巡常行"项目',
        link: window.location.href.split('#')[0], // 使用完整URL分享
        imgUrl: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/logo.jpg'
      };
    },

    // 初始化微信分享
    async initializeWxShare(forceRefresh = false) {
      // 如果不在微信中，直接返回
      if (!isWeixinBrowser()) {
        this.shareInitialized = false;
        return false;
      }

      // 如果正在初始化，避免重复调用
      if (this.isWxShareInitializing && !forceRefresh) {
        console.log('微信分享正在初始化中，跳过常规调用');
        return false;
      }

      try {
        console.log('开始初始化微信分享, 强制刷新:', forceRefresh);
        this.isWxShareInitializing = true;
        const shareData = this.getShareData();
        
        let success = false;
        success = await forceInitWxShare(shareData);
        
        this.isWxShareInitializing = false;
        
        if (success) {
          console.log('微信分享初始化成功');
          this.shareInitialized = true;
          this.initRetryCount = 0;
          return true;
        } else {
          console.log('微信分享初始化失败');
          this.shareInitialized = false;
          if (this.pageFullyLoaded && this.initRetryCount < 5) {
            this.initRetryCount++;
            console.log(`初始化失败，${this.initRetryCount}秒后重试 (${this.initRetryCount}/5)`);
            if (this.initRetryTimer) clearTimeout(this.initRetryTimer);
            this.initRetryTimer = setTimeout(() => {
              this.initializeWxShare(true);
            }, this.initRetryCount * 1000);
          }
          return false;
        }
      } catch (error) {
        console.error('微信分享初始化异常:', error);
        this.isWxShareInitializing = false;
        this.shareInitialized = false;
        if (this.initRetryCount < 5) {
          this.initRetryCount++;
          console.log(`初始化异常，${this.initRetryCount}秒后重试 (${this.initRetryCount}/5)`);
          if (this.initRetryTimer) clearTimeout(this.initRetryTimer);
          this.initRetryTimer = setTimeout(() => {
            this.initializeWxShare(true);
          }, this.initRetryCount * 1000);
        }
        return false;
      }
    },

    // 处理页面加载完成
    async handlePageLoaded() {
      console.log('页面完全加载完成，尝试初始化微信分享');
      this.pageFullyLoaded = true;
      if (isWeixinBrowser()) {
        await this.initializeWxShare(true);
      }
    },

    // 处理页面可见性变化
    handleVisibilityChange() {
      if (document.visibilityState === 'visible' && isWeixinBrowser()) {
        console.log('页面变为可见，尝试刷新微信分享配置');
        this.initializeWxShare(true);
      }
    },
    openZhibo(address) {
      window.open(address, '_blank');
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      this.handleScroll();
    });
  },
  computed: {
    lastZhiboList() {
      return this.zhiboList.slice(-2);
    }
  },
};
</script>

<style scoped>
.yi img {
  width: 100%;
  height: 470px;
}

.login-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.news-container {
  width: 800px;
  padding: 20px 20px 20px 20px;
}

.breadcrumb {
  margin-bottom: 20px;
  color: #666;
  font-size: 14px;
}

.breadcrumb .separator {
  margin: 0 8px;
  color: #999;
}

.news-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.news-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.more-link {
  color: #999;
  text-decoration: none;
  font-size: 14px;
}

/* 大图新闻样式 */
.featured-news {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
}

.featured-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: visible;
  border-radius: 8px;
  background: #fff;
  /* 不设置固定高度，内容自适应 */
}

.featured-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.3s ease;
  border-radius: 8px;
}

.featured-item img:hover {
  transform: scale(1.05);
}

/* 新闻列表样式 */
.news-list {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.news-item {
  width: calc(50% - 7.5px);
  display: flex;
  gap: 15px;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
  height: 120px;
}

.news-content {
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.news-content h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #333;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.news-excerpt {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin: 0 0 8px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1;
}

.news-info {
  display: flex;
  gap: 10px;
  color: #999;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
}

.news-img {
  width: 120px;
  height: 80px;
  margin-left: 15px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.news-img img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 改为contain确保图片完整显示不裁剪 */
  transition: transform 0.3s ease;
}

.login-page {
  width: 300px;
  min-height: 340px;
  height: auto;
  max-width: 500px;
  padding: 10px 35px;
  border-radius: 12px;
  background: linear-gradient(to bottom, lch(97.7% 6.64 212.46), rgba(233,247,255, 0));
  margin-bottom: 20px;
  margin-top: 120px;
  box-shadow: none;
}

.login-page p {
  margin: 0;
  /* padding-bottom: 20px; */
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

/* 修改登录选项卡样式 */
.login-tabs {
  display: flex;
  margin-bottom: 10px;
  border-bottom: none;
  gap: 20px;
}

.login-tabs button {
  background-color: transparent;
  border: none;
  padding: 8px 0;
  font-size: 15px;
  cursor: pointer;
  color: #999;
  position: relative;
  transition: all 0.3s ease;
}

.login-tabs button.active {
  color: #39bcad;
  font-weight: 500;
  background: transparent;
  padding: 8px 0;
  position: relative;
}

/* 添加选中状态的底部横线 */
.login-tabs button.active::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 3px; /* 横线粗细 */
  background: #39bcad;
  border-radius: 1.5px; /* 横线两端圆角 */
}

.form-content {
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
}

/* 修改输入框样式 */
input[type="text"], 
input[type="password"], 
select {
  padding: 12px 15px;
  margin: 8px 0;
  border: none;
  border-bottom: 1px solid #eee;
  border-radius: 8px;
  font-size: 14px;
  background: #fff;
  width: calc(100% - 30px);
}

/* 修改验证码区域样式 */
.captcha {
  display: flex;
  align-items: center;
  margin: 8px 0;
  border: none;
  padding-bottom: 0;
  gap: 10px;
  width: calc(100% - 30px);
}

.captcha input {
  flex: 1;
  margin: 0;
  border: none;
  border-bottom: 1px solid #eee;
  padding: 12px 15px;
  background: #fff;
  border-radius: 8px;
}

.send-captcha-btn {
  padding: 12px 15px;
  color: #39bcad;
  font-size: 14px;
  font-weight: normal;
  white-space: nowrap;
  flex-shrink: 0;
  border: none;
  background: #fff;
  border-radius: 8px;
  border-bottom: 1px solid #eee;
  opacity: 0.5;
  cursor: not-allowed;
}

.send-captcha-btn.active {
  opacity: 1;
  cursor: pointer;
}

.checkbox {
  display: flex;
  align-items: center;
  margin: 15px 0;
  font-size: 12px;
  color: #999;
}

.checkbox label {
  font-size: 12px;
  color: #999;
}

.checkbox label a {
  color: #45b7a9;
  text-decoration: none;
  font-weight: bold;
}

.register-link {
  margin-left: auto;
  margin-top: 0;
  display: flex;
  gap: 15px; /* 添加间距 */
}

.register-link label {
  margin: 0; /* 移除默认的 margin */
}

.register-link a {
  color: #999;
  text-decoration: none;
}

.register-link a:hover {
  color: #58C1B6;
}

.register-text {
  font-size: 16px;
  color: #0385EB;
}

.forgot-text {
  font-size: 16px;
  color: #999;
}

.forgot-text:hover {
  color: #0385EB;
}

.login-btn {
  padding: 12px;
  background-image: linear-gradient(to right, #2bcc9f 0%,#649ab9 100% );
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: calc(100% - 30px);
  margin: 5px 15px;
  font-size: 16px;
}

/* 平板设备 */
@media screen and (max-width: 1024px) {
  .login-container {
    flex-direction: column;
    gap: 30px;
  }
  
  .news-container {
    width: 100%;
    max-width: 600px;
  }
  
  .login-page {
    width: 90%;
    max-width: 400px;
  }
}

/* 手机设备 */
@media screen and (max-width: 768px) {
  .yi img {
    height: auto;
    max-height: 300px;
  }
  
  .login-container {
    padding: 10px;
    gap: 20px;
    flex-direction: column;
    align-items: center;
  }
  
  .mobile-hidden {
    display: none;
  }
  
  .news-container {
    width: 100%;
    max-width: 500px;
    padding: 15px;
  }
  
  .san img {
    width: 100%;
    max-width: 250px;
    height: auto;
  }
  
  .si img {
    height: auto;
    max-height: 500px;
  }
  
  .login-page {
    width: 90%;
    max-width: 350px;
    padding: 15px;
    margin-top: 20px;
  }
  
  /* 修改验证码区域样式 */
  .captcha {
    display: flex;
    flex-direction: row !important; /* 强制横向排列 */
    align-items: center;
    gap: 5px;
    width: 100%;
    margin: 8px 0;
  }
  
  .captcha input {
    flex: 0 1 60%;
    max-width: 60%; /* 限制验证码输入框宽度 */
    margin-right: 0;
    margin-bottom: 0 !important;
    height: 36px;
  }
  
  .captcha-img {
    height: 36px !important; /* 与输入框相同高度 */
    width: auto !important; /* 宽度自适应，保持图片比例 */
    flex-shrink: 0; /* 防止图片被压缩 */
    margin-left: 5px;
  }
  
  .send-captcha-btn {
    width: auto !important;
    white-space: nowrap;
    padding: 10px !important;
    flex-shrink: 0;
    height: 36px;
    font-size: 12px;
  }
  
  /* 修复复选框和文本不在同一行的问题 */
  .checkbox {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    gap: 5px;
    margin: 10px 0;
  }
  
  .checkbox input[type="checkbox"] {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    margin-right: 5px;
  }
  
  .checkbox label {
    font-size: 12px;
    white-space: nowrap;
    margin-right: 5px;
    display: inline-flex;
    align-items: center;
  }
  
  /* 移动端最新资讯样式优化 */
  .featured-news {
    flex-direction: column;
    gap: 15px;
  }
  
  .featured-item {
    width: 100%;
  }
  
  .news-list {
    flex-direction: column;
  }
  
  .news-item {
    width: 100%;
    flex-direction: column;
    height: auto;
    gap: 10px;
  }
  
  .news-img {
    width: 100%;
    height: 200px;
    margin-left: 0;
  }
}

/* 登录验证码样式 */
.login-form .captcha {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
}

.login-form .captcha input {
  flex: 1;
  margin-right: 5px;
  min-width: 0;
}

.login-form .captcha-img {
  height: 40px; /* 调整为与输入框相同高度 */
  width: auto; /* 宽度自适应，保持图片比例 */
  cursor: pointer;
  border-radius: 4px;
  object-fit: cover;
  margin-left: 10px;
}

/* 注册验证码样式 */
.form-content .captcha {
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-content .captcha input {
  flex: 1;
}

.form-content .captcha-img {
  height: 40px; /* 调整为与输入框相同高度 */
  width: auto; /* 宽度自适应，保持图片比例 */
  cursor: pointer;
  border-radius: 4px;
  object-fit: cover;
}

/* 修改滑动验证条的样式 */
.slider-container {
  width: 250px; /* 固定宽度为250px */
  height: 34px;
  position: relative;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin: 8px 0;
  touch-action: none; /* 防止触摸时的浏览器默认行为 */
}

.slider-mask {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #e8f7f6;
  border-radius: 8px;
}

.slider-button {
  position: absolute;
  left: 0;
  top: 0;
  width: 34px;
  height: 34px;
  background-color: white;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-button:hover {
  background-color: #f9f9f9;
}

.slider-text {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 34px;
  color: #999;
  font-size: 14px;
  user-select: none;
}

/* 修改项目部分样式 */
.project-sections {
width: 100%;
max-width: none;
margin: 0;
/* padding: 40px 0; */
padding: 40px 0 0 0;
/* background: #f8fbff; */
}

/* 标签栏样式 */
.section-tabs {
display: flex;
justify-content: space-between;
margin: 0 auto 30px auto;
background: #cfcfcf;
border-radius: 25px;  /* 增加圆角使两端呈现半圆 */
width: 80%;
max-width: 1200px;
height: 45px;  /* 增加高度 */
}

.tab {
flex: 1;  /* 让按钮平均占据空间 */
border: none;
background: transparent;
cursor: pointer;
font-size: 16px;
color: #666;
height: 100%;  /* 让按钮高度填满容器 */
border-radius: 25px;  /* 与容器相同的圆角 */
margin: 0;  /* 移除外边距 */
padding: 0;  /* 移除内边距 */
transition: all 0.3s ease;
}

.tab.active {
color: #fff;
background-image: linear-gradient(to right, #2bcc9f 0%, #649ab9 100%);  /* 使用与登录按钮相同的渐变色 */
}

/* 移除之前的边框和间距样式 */
.tab:not(:last-child) {
margin-right: 0;
}

/* 内容区域左对齐 */
.section-tou,
.section-er {
width: 100%;  /* 修改为100%宽度 */
max-width: none;  /* 移除最大宽度限制 */
margin: 0;  /* 移除自动边距 */
margin-bottom: 20px;
padding: 30px 0;  
/* padding: 100px 0 30px 0; */
}

/* 标题左对齐 */
.section-tou h2,
.section-er h2,
.section-san h2 {
font-size: 24px;
font-weight: bold;
color: #333;
margin-bottom: 20px;
text-align: left;  /* 添加左对齐 */
max-width: 1200px;
margin-left: auto;
margin-right: auto;
padding: 0 30px;
}



.section-tou .section-neirong,
.section-er .section-neirong,
.section-san .section-neirong {
max-width: 1200px;
margin-left: auto;
margin-right: auto;
}

/* 背景色 */
.section-tou {
background: #f8fdff;
}

.section-er {
background: #ffffff;
}

.section-san {
background: #f8fdff;
}

/* 内容区域文字样式调整 */
.section-neirong {
background: #effdff;
width: 80%;
margin: 0 auto;
padding: 30px;
border-radius: 0;  /* 移除圆角 */
max-width: 1200px;
margin-left: auto;
margin-right: auto;
}

.section-neirong p {
font-size: 14px;
line-height: 2.2;  /* 增加行间距 */
color: #666;
text-align: left;
margin: 0;
}

/* 响应式处理 */
@media screen and (max-width: 768px) {
.section-neirong {
  width: 90%;  /* 在小屏幕上稍微放宽一点 */
}
}

/* 目标区域样式 */
.goals-section {
max-width: 1200px;
margin: 0 auto;
margin-bottom: 20px;
padding: 30px;
background: #fff;
}

.goals-section h2 {
font-size: 24px;
font-weight: bold;
color: #333;
margin-bottom: 20px;
text-align: left;
}

.goals-container {
display: grid;
grid-template-columns: repeat(4, 1fr);
gap: 25px;  /* 增加间距到25px */
padding: 10px;  /* 添加内边距，防止阴影被裁切 */
}

.goal-item {
background: transparent;  /* 改为透明背景 */
border-radius: 12px;
padding: 0;
margin: 0;
transition: all 0.3s ease;
text-align: center;
box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
overflow: hidden;  /* 添加这个属性确保内容不会溢出圆角 */
}

.goal-item:hover {
transform: translateY(-5px);
box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);  /* hover时加深阴影 */
}

.goal-icon {
width: 100%;
height: 100%;  /* 改为100%高度 */
display: block;  /* 添加这个属性消除可能的间隙 */
margin: 0;
padding: 0;
}

.goal-icon img {
width: 100%;
height: 100%;
object-fit: cover;  /* 改为cover确保填满整个容器 */
display: block;  /* 添加这个属性消除可能的间隙 */
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
.goals-container {
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;  /* 减小间距 */
  padding: 5px;  /* 减小内边距 */
}

.goal-item {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);  /* 减小阴影 */
}

.goal-item:hover {
  transform: translateY(-3px);  /* 减小上移距离 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);  /* 减小hover时的阴影 */
}
}

@media screen and (max-width: 480px) {
.goals-container {
  grid-template-columns: repeat(2, 1fr);  /* 保持两列布局 */
  gap: 10px;  /* 进一步减小间距 */
  padding: 5px;  /* 保持小内边距 */
}

.goal-item {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);  /* 进一步减小阴影 */
}

.goal-item:hover {
  transform: translateY(-2px);  /* 进一步减小上移距离 */
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);  /* 进一步减小hover时的阴影 */
}
}

/* 组织架构两栏布局样式 */
.org-structure .org-columns {
display: flex;
gap: 40px;
justify-content: space-between;
}

.org-structure .org-column {
flex: 1;
display: flex;
flex-direction: column;
gap: 20px;
}

.org-row {
display: flex;
align-items: flex-start;
margin-bottom: 10px;
transition: all 0.3s ease;
position: relative;
z-index: 1;
}

.org-row:hover {
transform: translateY(-3px);
}

.org-item {
display: flex;
align-items: flex-start;
width: 100%;
background: #f9f9f9;
border-radius: 10px;
padding: 15px;
box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
transition: all 0.3s ease;
position: relative;
overflow: hidden;
}

.org-item:hover {
box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
background: #ffffff;
}

/* 添加左侧装饰条 */
.org-item::before {
content: '';
position: absolute;
left: 0;
top: 0;
height: 100%;
width: 4px;
background: linear-gradient(to bottom, #37ecba, #72afd3);
border-radius: 2px;
}

.org-label {
flex-shrink: 0;
width: 120px;
color: #333;
font-weight: bold;
position: relative;
display: flex;
align-items: center;
}

/* 添加小图标 */
.org-label::before {
content: '';
display: inline-block;
width: 8px;
height: 8px;
background: linear-gradient(to right, #37ecba, #72afd3);
border-radius: 50%;
margin-right: 10px;
}

.org-content {
flex: 1;
color: #666;
line-height: 1.8;
padding-left: 10px;
border-left: 1px dashed #e0e0e0;
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
.org-structure .org-columns {
  flex-direction: column;
  gap: 20px;
}

.org-item {
  flex-direction: column;
  padding: 12px;
}

.org-label {
  width: 100%;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #e0e0e0;
}

.org-content {
  padding-left: 0;
  border-left: none;
}
}

/* 增加标题样式 */
.section-san h2 {
position: relative;
margin-bottom: 20px;
max-width: 1200px;
margin-left: auto;
margin-right: auto;
padding: 0 30px;
display: block;
text-align: left;
font-size: 24px;
font-weight: bold;
color: #333;
}

.section-san h2::after {
display: none; /* 移除装饰线，与其他标题保持一致 */
}

/* 增加美化的组织架构背景 */
.section-neirong.org-structure {
background: #f7fbff;
border-radius: 15px;
box-shadow: 0 5px 25px rgba(0, 0, 0, 0.03);
padding: 30px;
position: relative;
overflow: hidden;
}

/* 添加背景装饰 */
.section-neirong.org-structure::before {
content: '';
position: absolute;
right: -80px;
top: -80px;
width: 200px;
height: 200px;
background: linear-gradient(135deg, rgba(55, 236, 186, 0.1), rgba(114, 175, 211, 0.1));
border-radius: 50%;
z-index: 0;
}

.section-neirong.org-structure::after {
content: '';
position: absolute;
left: -60px;
bottom: -60px;
width: 150px;
height: 150px;
background: linear-gradient(135deg, rgba(114, 175, 211, 0.1), rgba(55, 236, 186, 0.1));
border-radius: 50%;
z-index: 0;
}

@media screen and (max-width: 480px) {
.section-neirong.org-structure {
  padding: 20px 15px;
}

.org-item {
  padding: 10px;
}

.section-san h2 {
  padding: 0 20px; /* 减小内边距 */
  font-size: 20px; /* 减小字体大小 */
}
}

/* 添加项目实施规划样式 */
.implementation-plan {
width: 100%;
height: auto;
min-height: 568px;
background-image: url('../../assets/实施规划图.png');
background-size: cover;
background-position: center;
background-repeat: no-repeat;
margin: 20px 0 0 0;
/* margin: 20px 0; */
position: relative;
padding: 60px 0 0 0;
overflow: hidden; 
}

.plan-content {
max-width: 1200px;
margin: 0 auto;
padding: 0 20px;
position: relative;
z-index: 1;
overflow: hidden; /* 加强溢出控制 */
}

.plan-content h2 {
color: #fff;
font-size: 32px;
font-weight: bold;
margin-bottom: 50px;
text-align: left; /* 改为左对齐 */
padding-left: 20px; /* 添加左侧内边距 */
}

.plan-stages {
display: grid;
grid-template-columns: repeat(4, 1fr);
gap: 15px; /* 减小间距避免溢出 */
align-items: flex-end; /* 让所有子元素向下对齐 */
max-width: 100%; /* 确保不超出父容器宽度 */
overflow: visible; /* 设置为visible以确保内容可见 */
}

.plan-stage {
background: rgba(66, 66, 66, 0.205);
backdrop-filter: blur(5px);
border-radius: 16px;
padding: 15px; 
color: #fff;
min-height: unset; /* 移除之前设置的统一最小高度 */
width: 100%; /* 采用100%宽度 */
min-width: 0; /* 防止内容撑开容器 */
display: flex;
flex-direction: column;
overflow: hidden; /* 溢出内容隐藏 */
margin-top: auto; /* 将每个阶段推到底部 */
box-sizing: border-box; /* 确保内边距不会增加元素宽度 */
}

/* 第一阶段 */
.plan-stage:nth-child(1) {
height: 320px;
}

/* 第二阶段 */
.plan-stage:nth-child(2) {
height: 280px;
}

/* 第三阶段 */
.plan-stage:nth-child(3) {
height: 240px;
}

/* 第四阶段 */
.plan-stage:nth-child(4) {
height: 200px;
}

.stage-content {
height: 100%;
display: flex;
flex-direction: column;
justify-content: space-between; /* 内容上下分散对齐 */
gap: 20px; /* 添加内容间距 */
overflow: hidden; /* 溢出内容隐藏 */
}

.stage-content p {
font-size: 14px;
line-height: 1.8;
margin-bottom: 0; /* 移除底部边距，因为已经使用了gap */
color: #d8d8d8;
overflow-wrap: break-word; /* 确保长单词可以断行 */
word-wrap: break-word; /* 兼容旧浏览器 */
}

.stage-items {
display: grid;
grid-template-columns: 1fr 1fr;
gap: 5px 10px;
margin-top: auto;
overflow: hidden; /* 溢出内容隐藏 */
}

.stage-item {
background: rgba(255, 255, 255, 0.2);
padding: 8px 15px;
border-radius: 20px;
font-size: 14px;
text-align: center;
transition: all 0.3s ease;
}

.stage-item:hover {
background: rgba(255, 255, 255, 0.3);
transform: translateY(-2px);
}

.stage-text {
color: #fff;
font-size: 14px;
line-height: 1.8;
padding-left: 5px;
white-space: normal; /* 允许文本换行 */
overflow-wrap: break-word; /* 确保长单词可以断行 */
word-wrap: break-word; /* 兼容旧浏览器 */
}

.welcome-text {
font-size: 28px;
font-weight: bold;
color: #333;
text-align: center;
margin-bottom: 20px;
}

.user-logged-in {
display: flex;
align-items: center;
justify-content: center;
min-height: 340px;
padding: 20px;
}

.user-buttons {
display: flex;
flex-direction: column;
gap: 20px;
width: 100%;
max-width: 250px;
align-items: center; /* 确保所有内容居中 */
}

/* 确保作品提交图片样式与登录前一致 */
.user-buttons .san {
margin-top: 10px;
text-align: center;
}

.user-buttons .san img {
max-width: 100%;
height: auto;
}

.user-action-btn {
width: 100%;
padding: 12px 0;
text-align: center;
background-image: linear-gradient(to right, #2bcc9f 0%, #649ab9 100%);
color: white;
border-radius: 8px;
cursor: pointer;
font-size: 16px;
transition: all 0.3s ease;
border: none;
}

.user-action-btn:hover {
opacity: 0.9;
transform: translateY(-2px);
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.plan-stage:last-child .stage-content {
justify-content: flex-start; /* 改为从顶部开始对齐 */
gap: 10px; /* 两段文字之间的间距 */
}

.gradient-bottom {
width: 100%; /* 宽度设为100% */
height: 120px;
background-image: linear-gradient(to right, #37ecba 0%, #72afd3 100%);
box-sizing: border-box; /* 确保内边距不会增加元素宽度 */
display: flex; /* 添加 flex 布局以居中内容 */
justify-content: center; /* 水平居中 */
align-items: center; /* 垂直居中 */
overflow: hidden; /* 溢出隐藏 */
}

.button-container {
max-width: 1200px; /* 与 plan-content 的最大宽度一致 */
width: 100%; /* 占满可用宽度 */
height: 100%; /* 继承 gradient-bottom 的高度 */
display: grid; /* 使用 grid 布局 */
grid-template-columns: repeat(4, 1fr); /* 与 plan-stages 相同的四列布局 */
gap: 10px; /* 减小间距避免溢出 */
padding: 0 20px; /* 减小左右内边距 */
align-items: center; /* 确保按钮在网格中垂直居中 */
box-sizing: border-box; /* 确保内边距不会增加元素宽度 */
}

.gradient-button {
background: transparent; /* 未选中时背景透明 */
border: none; /* 移除边框 */
border-radius: 8px; /* 圆角 */
color: #fff; /* 白色文字 */
font-size: 16px; /* 减小字体大小 */
padding: 10px; /* 减小内边距 */
cursor: pointer; /* 鼠标悬停时显示指针 */
transition: all 0.3s ease; /* 过渡效果 */
width: 100%; /* 宽度100% */
height: 100%; /* 高度占满父容器 */
display: flex; /* 使用 flex 布局 */
justify-content: center; /* 水平居中 */
align-items: center; /* 垂直居中 */
text-align: center; /* 文字居中 */
box-sizing: border-box; /* 确保内边距不会增加元素宽度 */
min-width: 0; /* 防止内容撑开容器 */
overflow: hidden; /* 溢出内容隐藏 */
white-space: normal; /* 允许文本换行 */
}

.gradient-button:hover {
background-image: linear-gradient(to right, #37ecba 0%, #72afd3 100%);
transform: translateY(-2px); /* 轻微上移效果 */
}

.gradient-button.active {
background-image: linear-gradient(to right, #37ecba 0%, #72afd3 100%);
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
.welcome-text {
  font-size: 24px;
  margin-bottom: 15px;
}

.user-buttons .san img {
  max-width: 200px;
}

.implementation-plan {
  min-height: auto; /* 移除最小高度限制，让内容自然展开 */
  padding: 30px 0; /* 减少顶部内边距 */
  overflow: hidden; /* 确保在移动端也不会有横向滚动 */
}

.plan-content {
  padding: 0 10px; /* 减小左右内边距 */
  overflow: hidden; /* 确保在移动端也不会有横向滚动 */
}

.plan-content h2 {
  font-size: 24px; /* 减小标题字体 */
  margin-bottom: 20px; /* 减少底部间距 */
  padding-left: 10px;
}

.plan-stages {
  grid-template-columns: 1fr; /* 改为单列布局 */
  gap: 15px; /* 减小间距 */
  max-width: 100%; /* 确保不超出父容器宽度 */
  padding: 0 5px; /* 增加内边距 */
}

.plan-stage {
  height: auto !important; /* 移除固定高度，让内容决定高度，使用!important覆盖原先的设置 */
  min-height: unset; /* 移除最小高度 */
  min-width: 0; /* 设置为0而不是unset */
  width: 100%; /* 使用100%宽度 */
  padding: 15px; /* 减小内边距以防止溢出 */
  overflow: hidden; /* 确保内容不会溢出 */
  box-sizing: border-box; /* 确保内边距不会增加元素宽度 */
}

/* 移除每个阶段的固定高度 */
.plan-stage:nth-child(1),
.plan-stage:nth-child(2),
.plan-stage:nth-child(3),
.plan-stage:nth-child(4) {
  height: auto !important; /* 使用!important确保覆盖 */
}

.stage-content {
  gap: 10px; /* 减小内容间距 */
  height: auto; /* 高度自适应 */
  overflow: hidden; /* 确保内容不会溢出 */
}

.stage-content p {
  font-size: 13px; /* 略微减小字体 */
  line-height: 1.4; /* 减小行高 */
  white-space: normal; /* 允许文本换行 */
  overflow-wrap: break-word; /* 确保长单词可以断行 */
}

.stage-items {
  grid-template-columns: 1fr; /* 单列显示子项 */
  gap: 5px; /* 减小间距 */
  overflow: hidden; /* 确保内容不会溢出 */
}

.stage-text {
  white-space: normal; /* 允许文本换行 */
  font-size: 12px; /* 进一步减小字体 */
  padding-left: 0; /* 移除左侧内边距 */
  overflow-wrap: break-word; /* 确保长单词可以断行 */
  word-wrap: break-word; /* 兼容旧浏览器 */
}

.gradient-bottom {
  height: auto; /* 高度自适应 */
  padding: 15px 0; /* 减小上下内边距 */
  margin-left: 0; /* 移除左右外边距 */
  margin-right: 0; /* 移除左右外边距 */
  width: 100%; /* 使用100%宽度 */
}

.button-container {
  grid-template-columns: 1fr; /* 手机端改为单列 */
  gap: 10px; /* 减小间距 */
  padding: 0 10px; /* 减小左右内边距 */
  height: auto; /* 手机端高度自适应 */
  overflow: hidden; /* 确保内容不会溢出 */
}

.gradient-button {
  min-width: 0; /* 设置为0而不是unset */
  width: 100%; /* 按钮占满网格单元 */
  height: 45px; /* 降低按钮高度 */
  font-size: 14px; /* 减小字体大小 */
  padding: 8px; /* 减小内边距 */
  overflow: hidden; /* 确保内容不会溢出 */
  white-space: normal; /* 允许文本换行 */
}
}

@media screen and (max-width: 480px) {
.implementation-plan {
  padding: 20px 0; /* 进一步减少内边距 */
}

.plan-content h2 {
  font-size: 20px; /* 进一步减小标题字体 */
  margin-bottom: 15px; /* 进一步减少底部间距 */
}

.plan-stage {
  padding: 12px; /* 进一步减小内边距 */
}

.stage-content p {
  font-size: 12px; /* 进一步减小字体 */
}

.gradient-button {
  height: 40px; /* 进一步降低按钮高度 */
  font-size: 13px; /* 进一步减小字体大小 */
  padding: 5px; /* 进一步减小内边距 */
}
}
/* 精彩回顾模块样式 */
.jingcai {
width: 100%;
background: #f8fdff; /* 与 section-tou 背景色一致 */
padding: 40px 0;
}

.jingcai-content {
max-width: 1200px;
margin: 0 auto;
padding: 0 30px;
}

.jingcai-content h2 {
font-size: 24px;
font-weight: bold;
color: #333;
margin-bottom: 20px;
text-align: left;
}

.jingcai-container {
display: flex;
gap: 40px;
align-items: flex-start;
}

.jingcai-left {
flex: 1;
min-width: 550px;
}

.jingcai-img {
width: 100%;
height: 300px; /* 进一步增加图片高度，从 400px 改为 450px */
overflow: hidden;
border-radius: 8px;
margin-bottom: 15px;
}

.jingcai-img img {
width: 100%;
height: 100%;
object-fit: cover; /* 确保图片填满容器 */
object-position: center; /* 图片居中显示 */
border-radius: 8px;
}

.jingcai-right {
flex: 1.5;
min-width: 500px;
}

.jingcai-right h3 {
font-size: 18px;
font-weight: bold;
color: #333;
margin-bottom: 15px;
}

.jingcai-list {
list-style: none;
padding: 0;
margin: 0;
}

.jingcai-list-item {
font-size: 14px;
line-height: 1.8;
color: #666;
padding: 10px 0;
border-bottom: 1px solid #eee;
transition: all 0.3s ease; /* 添加过渡效果 */
}

.jingcai-event {
display: block; /* 确保事件名称独占一行 */
transition: transform 0.3s ease; /* 事件名称上移的过渡效果 */
}

.jingcai-guests {
display: none; /* 默认隐藏启动嘉宾内容 */
font-size: 14px;
line-height: 1.8;
color: #666;
padding-top: 5px; /* 与事件名称保持紧挨着 */
margin-bottom: 10px; /* 增加底部间距，避免与下方列表项重叠 */
}

/* 鼠标悬停效果 */
.jingcai-list-item:hover {
background: #f5f5f5; /* 悬停时背景色变化 */
}

.jingcai-list-item:hover .jingcai-event {
transform: translateY(-5px); /* 事件名称上移 */
}

.jingcai-list-item:hover .jingcai-guests {
display: block; /* 悬停时显示启动嘉宾内容 */
}

/* 响应式调整 */
@media screen and (max-width: 768px) {
.jingcai-container {
  flex-direction: column;
  gap: 20px;
}

.jingcai-left,
.jingcai-right {
  min-width: 100%;
}

.jingcai-img {
  height: 300px; /* 手机端调整图片高度，从 250px 增加到 300px */
}

.jingcai-list-item {
  padding: 8px 0; /* 手机端减小内边距 */
}

.jingcai-guests {
  padding-top: 5px;
  margin-bottom: 8px; /* 手机端减小底部间距 */
}
}

@media screen and (max-width: 480px) {
.jingcai-content {
  padding: 0 15px;
}

.jingcai-content h2 {
  font-size: 20px;
}

.jingcai-right h3 {
  font-size: 16px;
}

.jingcai-list-item {
  font-size: 13px;
}

.jingcai-guests {
  font-size: 12px;
}
}

.jingcai-info {
text-align: center; /* 添加文字居中对齐 */
margin: 10px 0; /* 添加上下边距 */
color: #666; /* 设置文字颜色 */
font-size: 14px; /* 设置文字大小 */
}

.register-text {
font-size: 16px;  /* 更大的字号 */
/* font-weight: 600; */
color: #0385EB; /* 使用主题蓝色 */
}

.org-structure {
  padding: 20px;
}

.org-primary {
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.primary-row {
  margin-bottom: 10px;
}

.primary-item {
  display: flex;
  align-items: center;
}

.primary-label {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  min-width: 120px;
}

.primary-content {
  font-size: 20px;
  color: #0385EB;
  font-weight: bold;
}

.org-secondary {
  padding: 15px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.org-columns {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.org-column {
  flex: 1;
}

.org-row {
  margin-bottom: 10px;
}

.org-item {
  display: flex;
  align-items: flex-start;
}

.org-label {
  font-size: 15px;
  color: #666;
  min-width: 90px;
}

.org-content {
  font-size: 15px;
  color: #333;
  flex: 1;
}

@media screen and (max-width: 768px) {
  .org-columns {
    flex-direction: column;
    gap: 10px;
  }

  .primary-label,
  .primary-content {
    font-size: 18px;
  }

  .org-label,
  .org-content {
    font-size: 14px;
  }
}

.forgot-text {
  font-size: 16px;
  color: #999;
  margin-left: 15px;
}

.forgot-text:hover {
  color: #0385EB;
}

/* 密码修改表单样式 */
.password-form {
  padding: 0 20px;
}

.form-item {
  margin-bottom: 20px;
}

.form-label {
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
}

.verify-code-input {
  display: flex;
  gap: 10px;
}

.verify-code-input .el-input {
  flex: 1;
}

.send-code-btn {
  width: 120px;
  white-space: nowrap;
  background-color: #58C1B6 !important;
  border-color: #58C1B6 !important;
  color: #fff !important;
}

.send-code-btn:hover {
  background-color: #4BA89E !important;
  border-color: #4BA89E !important;
}

.send-code-btn:disabled {
  background-color: #58C1B6 !important;
  border-color: #58C1B6 !important;
  opacity: 0.6;
}

/* 移动端适配样式 */
@media screen and (max-width: 768px) {
  .password-form {
    padding: 0;
  }
  
  .form-item {
    margin-bottom: 12px;
  }
  
  .form-label {
    font-size: 12px;
    margin-bottom: 4px;
  }
  
  .verify-code-input {
    gap: 5px;
  }
  
  .send-code-btn {
    width: auto;
    padding: 6px 8px;
    font-size: 12px;
    height: 32px;
  }
  
  /* 调整 Element UI 弹窗样式 */
  :deep(.el-dialog) {
    width: 85% !important;
    margin: 0 auto !important;
  }
  
  :deep(.el-dialog__body) {
    padding: 8px !important;
  }
  
  :deep(.el-dialog__header) {
    padding: 12px !important;
  }
  
  :deep(.el-dialog__title) {
    font-size: 15px !important;
  }
  
  :deep(.el-dialog__footer) {
    padding: 8px !important;
  }
  
  :deep(.el-input__inner) {
    height: 32px !important;
    line-height: 32px !important;
    font-size: 13px !important;
  }
  
  :deep(.el-button) {
    padding: 6px 12px !important;
    font-size: 12px !important;
    height: 32px !important;
  }
}

/* 修改弹窗中的按钮悬停样式 */
:deep(.el-button--primary:hover),
:deep(.el-button--primary:focus) {
  background-color: #4BA89E !important;
  border-color: #4BA89E !important;
}

/* 超小屏幕适配 */
@media screen and (max-width: 320px) {
  .password-form {
    padding: 0;
  }
  
  .verify-code-input {
    flex-direction: column;
    gap: 8px;
  }
  
  .send-code-btn {
    width: 100%;
    height: 30px !important;
  }
  
  :deep(.el-dialog) {
    width: 90% !important;
  }
  
  :deep(.el-dialog__body) {
    padding: 5px !important;
  }
  
  :deep(.el-input__inner) {
    height: 30px !important;
    line-height: 30px !important;
    font-size: 12px !important;
  }
  
  :deep(.el-button) {
    height: 30px !important;
    font-size: 12px !important;
  }
}
</style>


